import { ReactNode } from "react"
import store from "integrations/redux/store"
import { Provider } from "integrations/redux"

interface StorageProviderProps {
    children?: ReactNode
}

export const StorageProvider = ({ children }: StorageProviderProps) => {
    return <Provider store={store}>{children}</Provider>
}
